import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, Menu, X } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [
    { name: "Technology", path: "/" },
    { name: "Verticals", path: "/about" },
    { name: "Publishers", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  const handleLinkClick = (path) => {
    // If clicking on the same page, scroll to top
    if (location.pathname === path) {
      window.scrollTo(0, 0);
    }
    // Close mobile menu if open
    setIsOpen(false);
  };

  return (
    <nav className="fixed w-full z-50 transition-all duration-300 bg-white/70 backdrop-blur-xl border-b border-white/20 supports-[backdrop-filter]:bg-white/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <Link
            to="/"
            onClick={() => handleLinkClick("/")}
            className="flex items-center gap-3 group"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-blue-600 blur opacity-40 group-hover:opacity-60 transition duration-500 rounded-xl"></div>
              <div className="relative bg-gradient-to-tr from-blue-600 to-indigo-600 p-2.5 rounded-xl text-white shadow-lg">
                <Search className="h-6 w-6" />
              </div>
            </div>
            <span className="font-bold text-2xl tracking-tight text-slate-900">
              Searchy<span className="text-blue-600">.io</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => handleLinkClick(link.path)}
                className="text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => handleLinkClick("/contact")}
              className="px-6 py-3 text-sm font-bold text-white bg-slate-900 rounded-full hover:bg-blue-600 transition-all shadow-lg hover:shadow-blue-500/30 transform hover:-translate-y-0.5"
            >
              Partner Access
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-slate-600 hover:text-slate-900"
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gray-100 absolute w-full px-6 py-6 shadow-2xl">
          <div className="flex flex-col space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                onClick={() => handleLinkClick(link.path)}
                to={link.path}
                className="text-lg font-bold text-slate-800"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
